import React from 'react';
import { Navigate } from 'react-router-dom';

const GlobalSettings = () => {
  return <Navigate to="/admin/global-settings/keyword-blocking" replace />;
};

export default GlobalSettings;
